import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useThemeObserver } from '@atlaskit/tokens';

const withThemeObserverHOC = Component => {
  return props => {
    const theme = useThemeObserver();
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme
    }, props));
  };
};

export default withThemeObserverHOC;